import { compose } from 'js/utils/ramda.util';
import React, { useState, memo } from 'react';
import { Link } from 'js/components/common/Link';

import { useOnDownloadClick } from './hooks';

import style from './DownloadLink.scss';

export const DownloadLinkBare = ({ translate, reportType, transactionId }) => {
    const [isLoading, setIsLoading] = useState(false);
    const onDownloadClick = useOnDownloadClick({
        isLoading,
        reportType,
        setIsLoading,
        transactionId
    });

    return (
        <Link href="#" onClick={onDownloadClick} className={isLoading ? style.disabled : ''}>
            {translate(isLoading ? 'loading' : 'download')}
        </Link>
    );
};

export const DownloadLink = compose(
    memo
)(DownloadLinkBare);
